import { useCoreSelector } from '../../CoreStore';

import type { NickNameInfoProps } from './types';

export const useNickNameInfoSlice = {
  getIsNickNameEditOpen: (): boolean => useCoreSelector(({ nickNameInfo }) => nickNameInfo.isNickNameEditOpen),
  getNickNameInfo: (): NickNameInfoProps => useCoreSelector(({ nickNameInfo }) => nickNameInfo.nickNameInfo),
};
